import React, {Fragment} from 'react';
import ResultTable from './ResultTable';
import ResultGraph from './ResultGraph';
import IndicatorTable from "./IndicatorTable";
import {connect} from "react-redux";

const calculate = ({
                       annualRevenues,
                       discountRate,
                       otherCosts,
                       operationalCosts,
                       annualSavings,
                       capitalCosts
                   }) => {


    const years = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
    const toc = -operationalCosts - otherCosts;
    const netCashFlow = toc + 1 * annualRevenues + 1 * annualSavings;
    const yearly = years.map((v) => {
        const discount = 1 / Math.pow(1 + (discountRate / 100), v);
        console.log('discount', discount, netCashFlow, netCashFlow * discount);
        return {
            year: v,
            annualEnergySavings: 1 * annualRevenues + 1 * annualSavings,
            operationalCosts: -1 * operationalCosts,
            otherCosts: -1 * otherCosts,
            totalAnnualCosts: toc,
            netCf: netCashFlow,
            discountFactor: discount,
            discountedCf: netCashFlow * discount
        }
    });

    return yearly.reduce((acc, yr) => {
        const last = acc[acc.length - 1];
        yr.netCfCumulated = last.netCfCumulated + yr.netCf;
        yr.discountedCfCumulated = last.discountedCfCumulated + yr.discountedCf;
        acc.push(yr);
        return acc;
    }, [{
        year: 0,
        capitalCost: -capitalCosts,
        discountFactor: 1,
        netCf: -capitalCosts,
        netCfCumulated: -capitalCosts,
        discountedCfCumulated: -capitalCosts,
        discountedCf: -capitalCosts
    }]);


};


// seekZero seeks the zero point of the function fn(x), accurate to within x \pm 0.01. fn(x) must be decreasing with x.
function seekZero(fn) {
    var x = 1;
    while (fn(x) > 0) {
        x += 1;
    }
    while (fn(x) < 0) {
        x -= 0.01
    }
    return x + 0.01;
}

// Internal Rate of Return (IRR)
const IRR = (depth, args) => {

    let numberOfTries = 1;
    // Cash flow values must contain at least one positive value and one negative value
    let positive, negative;
    Array.prototype.slice.call(args).forEach(function (value) {
        if (value > 0) positive = true;
        if (value < 0) negative = true;
    });
    if (!positive || !negative) throw new Error('IRR requires at least one positive value and one negative value');

    function npv(rate) {
        numberOfTries++;
        if (numberOfTries > depth) {
            throw new Error('IRR can\'t find a result');
        }
        const rrate = (1 + rate / 100);
        let npv = args[0];
        for (var i = 1; i < args.length; i++) {
            npv += (args[i] / Math.pow(rrate, i));
        }
        return npv;
    }

    return Math.round(seekZero(npv) * 100) / 100;
};

const CalculatorResult = ({hasForm, valid, ...rest}) => {

    if (hasForm && valid) {
        const data = calculate(rest);
        const cfs = data.map(e => e.discountedCf);

        let irr = 0;
        try {
            irr = IRR(1000, cfs);
        } catch (e) {
            irr = 0;
        }
        const simplePayback = data.find(e => e.netCfCumulated > 0);
        const discountedPayback = data.find(e => e.discountedCfCumulated > 0);

        const indicators = {
            netPresent: data[20].discountedCfCumulated.toLocaleString(undefined, {maximumFractionDigits: 0}),
            simplePayback: simplePayback ? simplePayback.year : "non-refundable",
            discountedPayback: discountedPayback ? discountedPayback.year : "non-refundable",
            irr
        };

        return <Fragment>
            <IndicatorTable {...indicators}/>
            <ResultGraph data={data.slice(1).map(i => ({
                year: i.year,
                net: i.netCfCumulated.toFixed(0),
                discounted: i.discountedCfCumulated.toFixed(0)
            }))}/>
            <ResultTable data={data}/>

        </Fragment>;
    }
    return <div>Invalid</div>
};


const mapStateToProps = ({form: {calculator}}) => {
    const errors = calculator && calculator.syncErrors;
    const values = (calculator && calculator.values) || {};
    return {
        hasForm: typeof calculator !== "undefined",
        ...values,
        valid: (typeof calculator !== "undefined") && !errors,

    };
};
export default connect(mapStateToProps)(CalculatorResult);
